import { render } from "./CpuUsage.html?vue&type=template&id=3dd61120&ts=true"
import script from "./CpuUsage.ts?vue&type=script&lang=ts"
export * from "./CpuUsage.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__